import React from 'react';
import Modal from '@jbhi-fi/lanyard-ui/components/Modal';
import { CouponModalContent } from './CouponModalContent';
import { Coupon, CouponOffering } from '../types';
import { PerksContainer } from '../PerksContainer';
import { styles } from './CouponModal.css';
import { Confetti } from '@jbhi-fi/lanyard-ui/components/Confetti';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';

type CouponModalCoupon = Omit<Coupon, 'couponReference' | 'allocatedDate' | 'redemptionDate'>;

type CouponModalProps = {
  isOpen: boolean;
  coupon: CouponModalCoupon;
  isLoading: boolean;
  playCouponAppliedAnimation?: boolean;
  couponOffering?: CouponOffering;
  onApplyCoupon: (code: string) => void;
  onRemoveCoupon: (code: string) => void;
  onClose: () => void;
};

const getRedemptionCondition = (coupon: CouponModalCoupon) => {
  if (coupon.canBeRedeemedInStore && !coupon.canBeRedeemedOnline) {
    return 'instore';
  }
  if (coupon.canBeRedeemedOnline && !coupon.canBeRedeemedInStore) {
    return 'online';
  }
  return undefined;
};

export const CouponModal = ({
  isOpen,
  coupon,
  isLoading,
  playCouponAppliedAnimation,
  couponOffering,
  onApplyCoupon,
  onRemoveCoupon,
  onClose,
}: CouponModalProps) => {
  const isMobile = useBreakpoint('md', 'down');
  const redemptionCondition = getRedemptionCondition(coupon);
  return (
    <Modal show={isOpen} onClose={onClose} showFrame={true} frame={PerksContainer} customClass={styles.modal}>
      {playCouponAppliedAnimation ? (
        <Confetti
          triggerConfetti={playCouponAppliedAnimation}
          onComplete={onClose}
          origin={isMobile ? 'screenTop' : 'containerTop'}
        />
      ) : null}
      <CouponModalContent
        {...coupon}
        {...coupon.content}
        couponOffering={couponOffering}
        isLoading={isLoading}
        isApplied={coupon.isApplied}
        expiryDate={coupon.content?.expiryDateFormatted}
        termsAndConditions={coupon.content?.termsAndConditions}
        barcode={coupon.content?.barcode}
        redemptionCondition={redemptionCondition}
        onApplyCoupon={onApplyCoupon}
        onRemoveCoupon={onRemoveCoupon}
      />
    </Modal>
  );
};
